import { pattern } from './pattern';
export const websiteValidator = (value = '') => {
    const websiteRegex = new RegExp(pattern.website, "i");
    if (websiteRegex.test(value)) return true;
    else return false;
}